import { apiRequest } from "./apiClient";

export function getDashboardSummary(from, to) {
  const params = new URLSearchParams({ from, to });
  return apiRequest(`/api/dashboard/summary?${params.toString()}`);
}

